import { DoubleRightOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';

interface ViewPaymentDetailsButtonProps {
  onClick?: () => void;
}

const ViewPaymentDetailsButton: React.FC<ViewPaymentDetailsButtonProps> = ({
  onClick,
}) => {
  return (
    <GreyText onClick={onClick}>
      View payment breakdown <DoubleRightOutlined size={14} />
    </GreyText>
  );
};

export default ViewPaymentDetailsButton;

const GreyText = styled.p`
  font-size: 16px;
  font-weight: 400;
  color: #292929;
  text-decoration: underline;
`;
